import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponseModel, EmailAcknowledgeStatusModel, EmailAcknowledgeRequestModel } from '@grabbill/lib';
import { ApiHttpService } from './api-http.service';
import { EmailAcknowledgementApi } from '../api/email-acknowledgement.api';

@Injectable({
  providedIn: 'root',
})
export class EmailAcknowledgementService implements EmailAcknowledgementApi {
  readonly baseRoute = 'ack/email';

  constructor(private http: ApiHttpService) {}

  getStatus(token: string): Observable<ApiResponseModel<EmailAcknowledgeStatusModel>> {
    return this.http.get<ApiResponseModel<EmailAcknowledgeStatusModel>>(this.baseRoute, { token });
  }

  acknowledge(
    request: EmailAcknowledgeRequestModel
  ): Observable<ApiResponseModel<EmailAcknowledgeStatusModel>> {
    return this.http.post<ApiResponseModel<EmailAcknowledgeStatusModel>>(this.baseRoute, request);
  }
}
